import { useMemo } from 'react'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { OrganizationSelector } from './OrganizationSelector'
import { LanguageSwitcher } from './LanguageSwitcher'
import { NotificationDropdown } from './NotificationDropdown'
import { UserMenu } from './UserMenu'
import { ProfileSwitcher } from './ProfileSwitcher'
import { useProfileSwitch } from '@/contexts/ProfileSwitchContext'
import { useAuthStore } from '@/store/authStore'
import { Briefcase } from 'lucide-react'
import { useLocalization } from '@/contexts/LocalizationContext'

const ENTITY_TYPES = ['ENTITY', 'ORGANIZATION']

function BusinessClientBadge() {
  const { t } = useLocalization()
  return (
    <div className="hidden sm:flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-700">
      <Briefcase className="h-3.5 w-3.5" />
      <span className="text-xs font-medium">{t('profileSwitch.businessClient')}</span>
    </div>
  )
}

export function Header() {
  const { isBusinessClientMode, canSwitchProfiles } = useProfileSwitch()
  const user = useAuthStore((s) => s.user)

  const effectiveBC = useMemo(() => {
    if (isBusinessClientMode) return true
    const profiles = user?.profiles ?? []
    if (profiles.length === 0) return false
    const hasEntity = profiles.some((p) => ENTITY_TYPES.includes(p.profile_type))
    const hasBC = profiles.some((p) => p.profile_type === 'BUSINESS_CLIENT')
    return !hasEntity && hasBC
  }, [isBusinessClientMode, user?.profiles])

  return (
    <header className="flex h-14 sm:h-16 items-center justify-between border-b bg-white px-2 sm:px-4 gap-1 sm:gap-2">
      <div className="flex items-center gap-1 sm:gap-4 min-w-0 flex-1">
        <SidebarTrigger />
        {effectiveBC ? <BusinessClientBadge /> : <OrganizationSelector />}
      </div>
      <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
        {canSwitchProfiles && <ProfileSwitcher />}
        <LanguageSwitcher />
        <NotificationDropdown />
        <UserMenu />
      </div>
    </header>
  )
}
